import React from 'react'
import { Alert, AlertTitle } from '@material-ui/lab'
import { parseObjectKeysToString } from '../../../utils/Parse'
import { isEmpty } from 'ramda'

export const getErrorFromVeiculo = errors =>
  errors.map(error => {
    const cleanString = error
      .replace('[', ' ')
      .replace(']', '')
      .replace('s', '')
    return cleanString.slice(0, -1) + (Number(cleanString.slice(-1)) + 1)
  })

const RadioErrorsViewer = ({ radioErrors }) => {
  const { motorista, ...rest } = radioErrors
  const motoristaErrors = motorista && parseObjectKeysToString(motorista)
  const errors = rest && parseObjectKeysToString(rest)
  const veiculosErrors =
    errors &&
    getErrorFromVeiculo(errors.filter(error => error.includes('Veiculos')))

  const restErrors =
    errors && errors.filter(error => !error.includes('Veiculos'))

  return (
    <Alert severity="error" variant="filled">
      <AlertTitle>Campos não preenchidos</AlertTitle>
      Os seguintes campos precisam estar preenchidos:
      {motoristaErrors && (
        <>
          <br />
          Motorista: {motoristaErrors.join(', ')}
        </>
      )}
      {veiculosErrors &&
        veiculosErrors.map(error => (
          <>
            <br />
            {error}: CRLV Legivel
          </>
        ))}
      {!isEmpty(restErrors) && (
        <>
          <br />
          Outros: {restErrors.join(', ')}
        </>
      )}
    </Alert>
  )
}

export default RadioErrorsViewer
